module.exports = __webpack_public_path__ + "static/media/ticket-fan.021db8c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/scene--intro/ticket-fan.png
 ** module id = 466
 ** module chunks = 0
 **/